import styled from "styled-components";
import { H1 } from "@nested/nested-react-components";

const HeroTitle = styled(H1)`
  max-width: 800px;
  color: ${(props) => props.white && "white"};
  font-size: ${(props) => props.big && "100px"};
  text-align: center;
  margin-bottom: ${({ theme }) => theme.padding.base};
`;

HeroTitle.displayName = "HeroTitle";

export { HeroTitle };
